import { Instance } from 'mobx-state-tree';
import { RoutePaginatedDtoModelBase } from './RoutePaginatedDtoModel.base';

/* The TypeScript type of an instance of RoutePaginatedDtoModel */
export interface RoutePaginatedDtoModelType extends Instance<typeof RoutePaginatedDtoModel.Type> {}

/* A graphql query fragment builders for RoutePaginatedDtoModel */
export { selectFromRoutePaginatedDto, routePaginatedDtoModelPrimitives, RoutePaginatedDtoModelSelector } from './RoutePaginatedDtoModel.base';

/**
 * RoutePaginatedDtoModel
 */
export const RoutePaginatedDtoModel = RoutePaginatedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
